"use client";

import useProjectBuilder from '@/lib/hooks/useProjectBuilder';
import { ctDataToFormData } from '@/lib/tastics/project-builder-page/components/data';
import ProjectSummary from '@/lib/tastics/project-builder-page/components/project-summary';
import { FC, useEffect, useState, useCallback } from "react";

interface IProps {
  projectFormData?: any;
  data: any;
}

const ShareProject: FC<IProps> = ({ projectFormData, data }) => {
  const [projectData, setProjectData] = useState<any>(null);
  const { getProjectById } = useProjectBuilder();

  const fetchAndUpdateProjectData = useCallback(async (shoppingListId: string) => {
    try {
      const response: any = await getProjectById({ shoppingListId });
      const formattedData = ctDataToFormData(response?.data);
      setProjectData(formattedData ?? null);
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  }, [getProjectById]);

  useEffect(() => {
    if (projectFormData?.shoppingListId) {
      fetchAndUpdateProjectData(projectFormData.shoppingListId);
    }
  }, [projectFormData?.shoppingListId, fetchAndUpdateProjectData]);

  if (!projectData) return <></>;
  
  return (
    <div className="header-less-container">
      <ProjectSummary
        projectFormData={projectData}
        allowShare={true}
        data={data}
      />
    </div>
  );
};

export default ShareProject;
